export const NAV_HEIGHT = 72;
export const SUB_NAV_HEIGHT = 64;
export const COMMUNITIES_WIDTH = 64;
export const RAIL_WIDTH = 280;

export const GROUP_COLOR_SCHEMES = [
  {
    color: 'rgba(255, 255, 255, var(--color-scheme-opacity, 1))',
    theme: 'light'
  },
  {
    color: 'rgba(61, 61, 71, var(--color-scheme-opacity, 1))',
    theme: 'dark'
  },
  {
    color: 'rgba(252, 210, 62, var(--color-scheme-opacity, 1))',
    theme: 'light'
  },
  {
    color: 'rgba(92, 110, 248, var(--color-scheme-opacity, 1))',
    theme: 'dark'
  },
  {
    color: 'rgba(241, 155, 50, var(--color-scheme-opacity, 1))',
    theme: 'light'
  },
  {
    color: 'rgba(83, 175, 250, var(--color-scheme-opacity, 1))',
    theme: 'light'
  },
  {
    color: 'rgba(91, 201, 203, var(--color-scheme-opacity, 1))',
    theme: 'light'
  },
  {
    color: 'rgba(252, 121, 9, var(--color-scheme-opacity, 1))',
    theme: 'light'
  },
  {
    color: 'rgba(123, 96, 248, var(--color-scheme-opacity, 1))',
    theme: 'dark'
  },
  {
    color: 'rgba(237, 103, 99, var(--color-scheme-opacity, 1))',
    theme: 'dark'
  },
  {
    color: 'rgba(96, 218, 143, var(--color-scheme-opacity, 1))',
    theme: 'light'
  },
  {
    color: 'rgba(236, 71, 88, var(--color-scheme-opacity, 1))',
    theme: 'light'
  }
];
